import { render, staticRenderFns } from "./google.vue?vue&type=template&id=ae2570c4&scoped=true&"
import script from "./google.vue?vue&type=script&lang=js&"
export * from "./google.vue?vue&type=script&lang=js&"
import style0 from "./google.vue?vue&type=style&index=0&id=ae2570c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2570c4",
  null
  
)

export default component.exports